/*
 * File: /src/router/routes/tokens.js
 * Created Date: Thursday January 27th 2022
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Thursday, 27th January 2022 10:53:21 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2022 AdBase, Inc.
 */

const TokenPane = () =>
  import(
    /* webpackChunkName: "Tokens" */ 'src/components/Dashboard/Views/TokenTable/TokenList.vue'
  );

export const tokensRoutes = [
  {
    path: 'tokens',
    name: 'Token Table',
    component: TokenPane,
  },
];
